import { render, staticRenderFns } from "./PrintLabelManagement.vue?vue&type=template&id=06b2a48a&scoped=true"
import script from "./PrintLabelManagement.vue?vue&type=script&lang=js"
export * from "./PrintLabelManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2a48a",
  null
  
)

export default component.exports